import { ShiftDetailAssignedWorkers } from 'pages/ShiftDetailPage/assigned_workers/ShiftDetailAssignedWorkers'
import { useShiftDetail } from 'pages/ShiftDetailPage/useShiftDetail'
import { Box, Link, Loading } from 'ui'
import { useReviewEvaluateV2ContextValue } from '../context/ReviewEvaluateV2Provider'

export const WorkerEvaluationShiftWorkers = () => {
  const { shift, isLoading } = useShiftDetail()
  const {
    state: { filters },
  } = useReviewEvaluateV2ContextValue()

  if (isLoading) {
    return <Loading />
  }

  if (!shift) {
    return null
  }

  const showNeedsApprovalOnly = filters.reviewStatus === 'pending_review'
  const showApprovedOnly = filters.reviewStatus === 'reviewed'

  return (
    <>
      <ShiftDetailAssignedWorkers
        showUnfilledRows={false}
        showWorkerLabel
        showWorkerStatusBadge
        showNeedsApprovalOnly={showNeedsApprovalOnly}
        showApprovedOnly={showApprovedOnly}
        showBulkApproveButton={false}
      />
      <Box mb={3} ml={[0, 0, '6.5rem']}>
        <Link
          to={`/shift/${shift.id}`}
          onClick={(e) => {
            if (
              e.target instanceof Element &&
              e.target.closest('button, .modal-content')
            ) {
              e.preventDefault()
              e.stopPropagation()
            }
          }}
        >
          View All Timesheets
        </Link>
      </Box>
    </>
  )
}
